import React from 'react'
import { withTranslation } from 'react-i18next';
import Validate from '../../ressources/validation';



const ValidatePassword = ({ 
  value,
  activeColor = "#50af4e",
  styles = {},
  t, 
  children
}) => {
  const checkLength = !Validate('passwordLength', value)
  const checkMaj = !Validate('passwordMaj', value)
  const checkMin = !Validate('passwordMin', value)
  const checkSpecial = !Validate('passwordSpecial', value)

  return (
    <div>
      <div>
        {children}
      </div>
      <ul className="verif_mdp">
        <li style={{...styles.item , color: (checkLength) ? activeColor : '#cb5050'}}>
          {t("length")}
        </li>
        <li style={{...styles.item , color: (checkMaj) ? activeColor : '#cb5050'}}>
          {t("maj")}
        </li>
        <li style={{...styles.item , color: (checkMin) ? activeColor : '#cb5050'}}>
          {t("min")}
        </li>
        <li style={{...styles.item , color: (checkSpecial) ? activeColor : '#cb5050'}}>
          {t("special")}
        </li>
      </ul>
    </div>
  )
}

export default withTranslation()(ValidatePassword)